// Google Analytics initialization
// Only runs when VITE_ENABLE_GA is set to 'true'

if (import.meta.env.VITE_ENABLE_GA === 'true') {
  // Initialize Google Analytics for production
  gtag('js', new Date());
  gtag('config', 'G-99LEF200ZJ');
  
  console.log('Google Analytics initialized for production');
} else {
  console.log('Google Analytics disabled in development environment');
}